import { mapMutations, mapActions } from 'vuex'
import * as api from "../../api/index"
import Header from '../../components/header/header'
export default {
    data () {
        return {
            hotData:{
                ids:new Set(),
                allIds:new Set(),
                hotlist:[]
            },
            activeName: '',
            allData: {
                type: 0,
                menuId: 0,
                typeList: [],
                dataList: [],
            },
            currentPage: 1,// 当前页面
            dataTotal: 0, //图片总数
        }
    },
    created () {
        this.allData.type = Number(this.$route.query.type)
        this.getMoudleCategory()
    },
    components: {
        Header
    },
    methods: {
        ...mapActions('data', [
            'getCategory',
            'getCategoryData'
        ]),
        // 设置热门商品
        setHotProduct(){
            if(this.hotData.ids.size>20){
                this.$message.error('推荐商品必须小于20，当前'+this.hotData.ids.size)
                return
            }
            api.setHotProduct({type:this.allData.type,product_ids:JSON.stringify([...this.hotData.ids]),token:'eyJpdiI6Imd3MHJXSFpOOXp6Nm1xY3p4ODRZNVE9PSIsInZhbHVlIjoiWVkyK1pFZFExSENNWWZQSDNwOFh3VElXc2JvNWV5K1wvWW1BaklCVmhjXC83ZmlqNUduT2wwaUc0eHZCcFljNEhyIiwibWFjIjoiMDBmN2NhODEwOWI4YzhkOGI1ZWRmMjI3ZWU0YjY4ZWU2YTA5ODk5MWUwMzE3MjAxMDM4Y2FiMDMzNjhhMGNiOCJ9'},res=>{
                console.log(res);
                if(res.status == "success") {
                    this.$message.success('设置成功');
                    return
                }
                this.$message.error('设置失败');
            })
        },
        // 获取模板分类
        getMoudleCategory () {
            this.getCategory({
                type: this.allData.type,
            }).then(res => {
                this.allData.typeList = res
                this.allData.menuId = res[0].id
                this.activeName = res[0].name
                this.getListFun()
                this.getHotProduct()
            })
        },
        getHotProduct(){
            api.getHotProduct({type:this.allData.type,offset:'0',length:'9999'},res=>{
                this.hotData.hotlist = res.result[0].data
                this.hotData.hotlist.forEach(element => {
                    this.setHotId(element.product_id,'add')
                    this.$set(element,'hot', true)
                });
                this.setDataListHot()
            })
        },
        setHotId(id,operation="add"){
            if(operation==='add'){
                this.hotData.ids.add(id)
                this.hotData.allIds.add(id)
            }
            if(operation==='del'){
                this.hotData.ids.delete(id)
            }
        },
        // 取消热门
        cancleHot(index){
            this.hotData.hotlist[index].hot = !this.hotData.hotlist[index].hot
            this.setHotId(this.hotData.hotlist[index].product_id,
                this.hotData.hotlist[index].hot?'add':'del')
        },
        // 获取列表数据
        getListFun () {
            api.getList({
                offset: (this.currentPage - 1) * 20,
                length: 20,
                type: this.allData.type,
                menus_id: this.allData.menuId
            }, res => {
                if (res.status == 'success') {
                    this.allData.dataList = res.result.data
                    this.allData.dataList.forEach(element => {
                        this.$set(element,'hot', false)
                    });
                    this.setDataListHot()
                    this.dataTotal = res.result.total
                } else {
                    console.error('列表获取失败')
                }
            })
        },
        // 设置下方是否有已推荐商品
        setDataListHot(){
            this.allData.dataList.forEach(element => {
                if(this.hotData.allIds.has(element.product_id)) this.$set(element,'hot', true)
            });
        },
        // 选择当前分类
        handleClick (e) {
            this.allData.menuId = this.menuFilter(e.name)
            this.allData.dataList = []
            this.currentPage = 1
            this.dataTotal = 0
            this.getListFun()
        },
        // 分类名称转id
        menuFilter (name) {
            const menu = this.allData.typeList.find(item => {
                return item.name == name
            })
            return menu.id
        },
        // 切换页面
        handleCurrentChange (e) {
            this.currentPage = e
            this.getListFun()
            console.log(`当前页: ${e}`);
        },
        // 跳转详情页
        toDetail (index) {
            if(this.allData.dataList[index].hot) return
            this.allData.dataList[index].hot = true
            this.setHotId(this.allData.dataList[index].product_id,'add')
            this.hotData.hotlist.push(this.allData.dataList[index])
            // this.$router.push({
            //     path: '/product_detail',
            //     query: {
            //         type: type,
            //         menus_id: menuId,
            //         product_id: id
            //     }
            // })
        },
    }
}